import React from 'react';
import Tag from '@rio-cloud/rio-uikit/lib/es/Tag';
import CustomStepProgress from '~/features/base/components/CustomStepProgress';
import { Divider } from '@rio-cloud/rio-uikit';
import { Stage } from '~/api/models/stage';
import { ALL_STAGES_BUTTON } from '~/features/campaigns/components/campaign/CampaignStages/CampaignStages';

interface StagesStepperProps {
    onStageSelection: (selection: number | string) => void;
    stages: Stage[];
    initialStage?: number | string;
    currentStage?: number;
}

const StagesSelect: React.FC<StagesStepperProps> = ({ onStageSelection, stages, initialStage, currentStage }) => {
    const hasGroupsAssigned = stages.some(stage => stage?.vehicleGroup);

    return (
        <div className=' display-flex  '>
            <Tag
                active={initialStage === ALL_STAGES_BUTTON}
                clickable={hasGroupsAssigned}
                disabled={!hasGroupsAssigned}
                onClick={() => {
                    if (hasGroupsAssigned) {
                        onStageSelection(ALL_STAGES_BUTTON);
                    }
                }}>
                All stages
            </Tag>
            <Divider vertical/>
            <div className={'display-flex align-items-baseline'}>
                <span className={'margin-right-10'}> Stage </span>
                <CustomStepProgress
                    steps={stages.map((stage, index) => ({
                        number: index + 1,
                        status: stage.status,
                        currentStage: index + 1 === currentStage ? currentStage : undefined
                    }))}
                    activeStep={initialStage}
                    onStepClick={onStageSelection}
                    currentStep={currentStage}
                />

            </div>

        </div>
    );
};
export default StagesSelect;
